import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for J501 (樣品申請單核准)
// ============================================================

export interface ApproveCandidate {
  fj110_01: string;   // 樣品申請單號
  fj110_11: string;   // 申請日期 (YYYY-MM-DD)
  fj110_12: string;   // 客戶代碼
  fj110_21: string;   // 部門代碼
  fj110_22: string;   // 業務員代碼
  fj110_80: string;   // 核准狀態
  cust_name: string;  // 客戶名稱
  dept_name: string;  // 部門名稱
  sales_name: string; // 業務員姓名
}

export interface QueryResponse {
  items: ApproveCandidate[];
  total: number;
}

export interface ApproveItem {
  no: string;      // FJ110_01
  checked: boolean; // 是否勾選
}

export interface ApproveRequest {
  items: ApproveItem[];
  confirmed: boolean;
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const j501Api = {
  /** Query sample request records eligible for approval */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/j501/candidates', { params });
    return res.data;
  },

  /** Execute batch approval for selected sample request records */
  async approve(request: ApproveRequest): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/j501/approve', request);
    return res.data;
  },
};
